import { render, staticRenderFns } from "./economic-volume.vue?vue&type=template&id=79985a81&scoped=true"
import script from "./economic-volume.vue?vue&type=script&lang=js"
export * from "./economic-volume.vue?vue&type=script&lang=js"
import style0 from "./economic-volume.vue?vue&type=style&index=0&id=79985a81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79985a81",
  null
  
)

export default component.exports